export var getDate = function getDate(data, multiplier) {
  if (multiplier === void 0) {
    multiplier = 1000;
  }

  var months = [
    "\u042F\u043D\u0432\u0430\u0440\u044F",
    "\u0424\u0435\u0432\u0440\u0430\u043B\u044F",
    "\u041C\u0430\u0440\u0442\u0430",
    "\u0410\u043F\u0440\u0435\u043B\u044F",
    "\u041C\u0430\u044F",
    "\u0418\u044E\u043D\u044F",
    "\u0418\u044E\u043B\u044F",
    "\u0410\u0432\u0433\u0443\u0441\u0442\u0430",
    "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
    "\u041E\u043A\u0442\u044F\u0431\u0440\u044F",
    "\u041D\u043E\u044F\u0431\u0440\u044F",
    "\u0414\u0435\u043A\u0430\u0431\u0440\u044F",
  ];
  var monthsInit = [
    "\u042F\u043D\u0432\u0430\u0440\u044C",
    "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
    "\u041C\u0430\u0440\u0442",
    "\u0410\u043F\u0440\u0435\u043B\u044C",
    "\u041C\u0430\u0439",
    "\u0418\u044E\u043D\u044C",
    "\u0418\u044E\u043B\u044C",
    "\u0410\u0432\u0433\u0443\u0441\u0442",
    "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
    "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
    "\u041D\u043E\u044F\u0431\u0440\u044C",
    "\u0414\u0435\u043A\u0430\u0431\u0440\u044C",
  ];
  var days = [
    "\u0412\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0412\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0421\u0440\u0435\u0434\u0430",
    "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u041F\u044F\u0442\u043D\u0438\u0446\u0430",
    "\u0421\u0443\u0431\u0431\u043E\u0442\u0430",
  ];
  var time = {};
  var unixTime = new Date(data * multiplier);
  time.year = unixTime.getFullYear();
  time.month = months[unixTime.getMonth()];
  time.initMonth = monthsInit[unixTime.getMonth()];
  time.numMonth = unixTime.getMonth();
  time.date = unixTime.getDate();
  time.day = days[unixTime.getDay()];
  time.hour = unixTime.getHours();
  time.minute = unixTime.getMinutes();
  return time;
};
export var times = {
  getTime: function getTime(date) {
    if (date === void 0) {
      date = 1;
    }

    var obj = getDate(date);
    var minute = obj.minute.toString().length === 1 ? "0" + obj.minute : obj.minute;
    var str = obj.hour + ":" + minute;
    return str;
  },
  getDay: function getDay(date) {
    if (date === void 0) {
      date = 1;
    }

    var obj = getDate(date);
    var str = obj.day;
    return str;
  },
  getDayOfWeek: function getDayOfWeek(date) {
    if (date === void 0) {
      date = 1;
    }

    var obj = getDate(date);
    var str = obj.date + " " + obj.month;
    return str;
  },
  getFullDate: function getFullDate(date) {
    if (date === void 0) {
      date = 1;
    }

    var obj = getDate(date);
    var str = obj.date + " " + obj.month + " " + obj.year;
    return str;
  },
  getNumberDate: function getNumberDate(date) {
    if (date === void 0) {
      date = 1;
    }

    var obj = getDate(date);
    var day = obj.date < 10 ? "0" + obj.date : obj.date;
    var month = obj.numMonth < 9 ? "0" + (obj.numMonth + 1) : obj.numMonth + 1;
    var year = obj.year.toString().slice(2, 4);
    return day + "." + month + "." + year;
  },
  getYear: function getYear(date, m) {
    if (date === void 0) {
      date = 1;
    }

    var obj = getDate(date, m);
    var year = obj.year;
    return year;
  },
};
export var getCurrentPrice = function getCurrentPrice(prices) {
  var currentTime = Date.now() / 1000;
  return prices.find(function (p) {
    return currentTime < p.start_date;
  });
};
export var checkRegDate = function checkRegDate(date, multiplier) {
  if (multiplier === void 0) {
    multiplier = 1000;
  }

  return new Date() > new Date(date * multiplier);
};
